/** Kannada: the story of a job as the two agents told it. */
export const talk = {
    "talk.title": "ಏಜೆಂಟ್ ಮಾತುಕತೆ",
    "talk.request_mine": "ನಿಮ್ಮ ಏಜೆಂಟ್ ನಿಮ್ಮ ರಿಕ್ವೆಸ್ಟ್ ಅನ್ನು {name} ಅವರಿಗೆ ಕಳುಹಿಸಿತು.",
    "talk.request_theirs": "{name} ಅವರ ಏಜೆಂಟ್ ನಿಮ್ಮ ಏಜೆಂಟ್‌ಗೆ ರಿಕ್ವೆಸ್ಟ್ ಕಳುಹಿಸಿತು.",
    "talk.asked_mine": "ನಿಮ್ಮ ಏಜೆಂಟ್ ಕೇಳಿತು:",
    "talk.asked_theirs": "{name} ಅವರ ಏಜೆಂಟ್ ಕೇಳಿತು:",
    "talk.answered_mine": "ನೀವು ಉತ್ತರಿಸಿದಿರಿ:",
    "talk.answered_theirs": "{name} ಅವರು ಉತ್ತರಿಸಿದರು:",
    "talk.offer_mine": "ನಿಮ್ಮ ಏಜೆಂಟ್ {price} ಹೇಳಿತು.",
    "talk.offer_theirs": "{name} ಅವರ ಏಜೆಂಟ್ {price} ಹೇಳಿತು.",
    "talk.agreed": "ಎರಡೂ ಏಜೆಂಟ್‌ಗಳು {price} ಮೊತ್ತಕ್ಕೆ ಒಪ್ಪಿದವು.",
    "talk.signed_mine": "ನೀವು ಸಹಿ ಮಾಡಿದಿರಿ.",
    "talk.signed_theirs": "{name} ಅವರು ಸಹಿ ಮಾಡಿದರು.",
    "talk.contacts": "ಇಬ್ಬರೂ ಸಹಿ ಮಾಡಿದ್ದರಿಂದ ನಿಮ್ಮ ಸಂಪರ್ಕ ವಿವರಗಳನ್ನು ಒಬ್ಬರಿಗೊಬ್ಬರು ಹಂಚಲಾಯಿತು.",
    "talk.ended": "ಮಾತುಕತೆ ಮುಗಿಯಿತು: {reason}",
    "talk.private_provider": "ನಿಮ್ಮ ಕನಿಷ್ಠ ದರವನ್ನು ಎಂದೂ ಕಳುಹಿಸಲಿಲ್ಲ. ಅದು ಈ ಫೋನ್‌ನಲ್ಲೇ ಉಳಿಯಿತು.",
    "talk.private_requester": "ನಿಮ್ಮ ಬಜೆಟ್ ಅನ್ನು ಎಂದೂ ಕಳುಹಿಸಲಿಲ್ಲ. ಅದು ಈ ಫೋನ್‌ನಲ್ಲೇ ಉಳಿಯಿತು.",
    "decide.takeover_title": "ನಿಮ್ಮ ಏಜೆಂಟ್‌ಗಳು ಒಪ್ಪಿಗೆಗೆ ಬರಲಿಲ್ಲ",
    "decide.takeover_body": "ತಲಾ ಮೂರು ಆಫರ್‌ಗಳ ನಂತರ ಈಗ ನಿರ್ಧಾರ ನಿಮ್ಮದು. ಅವರ ಕೊನೆಯ ಆಫರ್: {price}.",
    "decide.accept_theirs": "{price} ಒಪ್ಪಿ",
    "decide.your_offer": "ನಿಮ್ಮ ಆಫರ್ (₹)",
    "decide.send_offer": "ನನ್ನ ಆಫರ್ ಕಳುಹಿಸಿ",
    "decide.end": "ಮಾತುಕತೆ ಮುಗಿಸಿ",
    "decide.time_title": "ಬೇರೆ ಸಮಯ",
    "decide.time_other": "ನೀವು ಕೇಳಿದ ಸಮಯದ ಬದಲು {name} {when} ಬರಬಹುದು.",
    "decide.time_passed": "ನೀವು ಕೇಳಿದ ಸಮಯ ಮುಗಿದಿದೆ.",
    "decide.time_passed_other": "ನೀವು ಕೇಳಿದ ಸಮಯ ಮುಗಿದಿದೆ. {name} {when} ಬರಬಹುದು.",
    "decide.accept_time": "ಹೌದು, {when}",
    "decide.pick_time": "ಬೇರೆ ಸಮಯ ಆರಿಸಿ",
    "decide.pick_send": "ಈ ಸಮಯ ಕಳುಹಿಸಿ",
    "a11y.takeover": "ನಿಮ್ಮ ಏಜೆಂಟ್‌ಗಳು ಒಪ್ಪಿಗೆಗೆ ಬರಲಿಲ್ಲ",
    "a11y.new_time": "ಬೇರೆ ಸಮಯ",
    "talks.take_over": "ನಿಮ್ಮ ಏಜೆಂಟ್‌ನಿಂದ ಮಾತುಕತೆ ವಹಿಸಿಕೊಳ್ಳಿ",
};
//# sourceMappingURL=talk.js.map